import front from './view';
import my from './my';
import cs from './cs';
import anew from './anew';
import search from './search';
import complaint from './complaint';

export default [
  {
    path: '/',
    component: front('/main'),
  },
  {
    path: 'guide',
    component: front('/guide'),
  },
  {
    path: 'join',
    component: front('/join/join'),
  },
  {
    path: 'joinComplete',
    component: front('/join/joinComplete'),
  },
  {
    path: 'passwordReset',
    component: front('/join/password'),
  },
  ...anew,
  ...cs,
  ...my,
  ...search,
  ...complaint,

  { path: '*', redirect: '/404' },
];



// WEBPACK FOOTER //
// ./src/router/front/index.js